/* Leucadia <-> Dawn integration glue.
 * - Hijack cart icon / /cart links -> open leucadia drawer
 * - Sync leucadia cart count into Dawn's cart-count-bubble
 * - Hide Dawn's cart-drawer / cart-notification
 * - On /pages/blanco|reposado|anejo (and any CHL product link):
 *     1. Rewrite hardcoded BUY NOW button label -> ADD TO CART, restyle to NOIR fill, hijack click to drawer
 *     2. Insert a BUY NOW button ABOVE the ATC, GOLD filled with noir text, calls LeucadiaCart.buyNow()
 */
(function () {
  'use strict';

  var PAGE_TO_LEU_HANDLE = {
    '/pages/blanco':   'leucadia®-blanco-tequila-copy',
    '/pages/reposado': 'leucadia®-reposado-tequila',
    '/pages/anejo':    'leucadia®-anejo-tequila'
  };

  var CHL_HANDLE_TO_LEU_HANDLE = {
    'leucadia®-silver-tequila':   'leucadia®-blanco-tequila-copy',
    'leucadia®-blanco-tequila':   'leucadia®-blanco-tequila-copy',
    'leucadia®-reposado-tequila': 'leucadia®-reposado-tequila',
    'leucadia®-anejo-tequila':    'leucadia®-anejo-tequila',
    'leucadia®-añejo-tequila':    'leucadia®-anejo-tequila'
  };

  /* Inject global CSS for both the injected Buy Now (gold filled) and the
   * restyled Add To Cart (noir filled). High contrast against any page bg. */
  function injectBuyNowStyles() {
    if (document.getElementById('leu-buy-now-global-styles')) return;
    var s = document.createElement('style');
    s.id = 'leu-buy-now-global-styles';
    s.textContent = [
      '/* Primary CTA: BUY NOW — gold fill, noir text, on top */',
      '.leu-buy-now-injected, .leu-buy-now-injected:link, .leu-buy-now-injected:visited {',
      '  display: flex !important;',
      '  align-items: center !important;',
      '  justify-content: center !important;',
      '  text-align: center !important;',
      '  margin: 0 !important;',
      '  min-height: 47px !important;',
      '  padding: 12px 24px !important;',
      '  background: #D4AF50 !important;',
      '  background-color: #D4AF50 !important;',
      '  color: #080808 !important;',
      '  border: 1.5px solid #D4AF50 !important;',
      '  font-family: inherit !important;',
      '  font-size: 13px !important;',
      '  font-weight: 700 !important;',
      '  letter-spacing: 2px !important;',
      '  line-height: 1 !important;',
      '  text-transform: uppercase !important;',
      '  text-decoration: none !important;',
      '  cursor: pointer !important;',
      '  transition: background-color 0.2s ease, color 0.2s ease, border-color 0.2s ease !important;',
      '  box-shadow: none !important;',
      '  opacity: 1 !important;',
      '  width: auto !important;',
      '  box-sizing: border-box !important;',
      '  white-space: nowrap !important;',
      '}',
      '.leu-buy-now-injected > * { text-align: center !important; }',
      '.leu-buy-now-injected:hover, .leu-buy-now-injected:focus {',
      '  background: #B8943F !important;',
      '  background-color: #B8943F !important;',
      '  color: #080808 !important;',
      '  border-color: #B8943F !important;',
      '}',
      '.leu-buy-now-injected:disabled {',
      '  opacity: 0.4 !important;',
      '  cursor: not-allowed !important;',
      '}',
      '/* Secondary CTA: ADD TO CART (restyled) — noir fill, white text, below */',
      '.leu-atc-restyled, .leu-atc-restyled:link, .leu-atc-restyled:visited {',
      '  background: #080808 !important;',
      '  background-color: #080808 !important;',
      '  color: #FFFFFF !important;',
      '  border: 1.5px solid #080808 !important;',
      '  transition: background-color 0.2s ease, color 0.2s ease, border-color 0.2s ease !important;',
      '}',
      '.leu-atc-restyled:hover, .leu-atc-restyled:focus {',
      '  background: #1a1a1a !important;',
      '  background-color: #1a1a1a !important;',
      '  color: #D4AF50 !important;',
      '  border-color: #1a1a1a !important;',
      '}',
      '/* Mobile: stack full-width with comfortable spacing */',
      '@media (max-width: 749px) {',
      '  .leu-buy-now-injected {',
      '    width: 100% !important;',
      '    min-height: 50px !important;',
      '    font-size: 14px !important;',
      '  }',
      '  .leu-buy-now-wrap-injected { width: 100% !important; }',
      '  .leu-atc-restyled { width: 100% !important; }',
      '}'
    ].join('\n');
    document.head.appendChild(s);
  }

  function leuCartCount() {
    return (window.LeucadiaCart && window.LeucadiaCart.count) ? window.LeucadiaCart.count() : 0;
  }

  function hijackCartLinks() {
    var sels = ['#cart-icon-bubble', '.header__icon--cart', 'a[href="/cart"]', 'a[href$="/cart"]'];
    var nodes = document.querySelectorAll(sels.join(','));
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      if (el.dataset.leuHijacked) continue;
      el.dataset.leuHijacked = '1';
      el.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopImmediatePropagation();
        if (window.LeucadiaCart) window.LeucadiaCart.open();
      }, true);
    }
  }

  function resolveLeuHandle(el) {
    if (!el) return null;
    var explicit = el.getAttribute && el.getAttribute('data-leu-handle');
    if (explicit) return explicit.toLowerCase();

    var href = el.getAttribute && el.getAttribute('href');
    if (href) {
      try {
        var u = new URL(href, location.origin);
        if (/coasthighwayliquor\.myshopify\.com$/i.test(u.hostname)) {
          var m = u.pathname.match(/\/products\/([^\/?#]+)/);
          if (m) {
            var chlHandle = decodeURIComponent(m[1]).toLowerCase();
            if (CHL_HANDLE_TO_LEU_HANDLE[chlHandle]) return CHL_HANDLE_TO_LEU_HANDLE[chlHandle];
            if (window.LEUCADIA_CHL && window.LEUCADIA_CHL.lookup && window.LEUCADIA_CHL.lookup(chlHandle)) return chlHandle;
          }
        }
      } catch (e) {}
    }

    var pageHandle = PAGE_TO_LEU_HANDLE[location.pathname.toLowerCase()];
    if (pageHandle) return pageHandle;

    return null;
  }

  /* Insert a BUY NOW button BEFORE the ATC (so Buy Now sits ON TOP).
   * Uses a plain <button> with full visual control via .leu-buy-now-injected. */
  function insertBuyNowButton(srcEl, handle) {
    if (!srcEl || !srcEl.parentNode) return;
    /* Don't double-insert. */
    if (srcEl.previousElementSibling && srcEl.previousElementSibling.querySelector && srcEl.previousElementSibling.querySelector('[data-leu-buy-now]')) return;
    if (srcEl.previousElementSibling && srcEl.previousElementSibling.hasAttribute && srcEl.previousElementSibling.hasAttribute('data-leu-buy-now')) return;
    if (srcEl.parentNode.querySelector('[data-leu-buy-now]')) return;

    var buyBtn = document.createElement('button');
    buyBtn.setAttribute('type', 'button');
    buyBtn.className = 'leu-buy-now-injected';
    buyBtn.setAttribute('data-leu-buy-now', '');
    buyBtn.setAttribute('data-leu-handle', handle);
    buyBtn.setAttribute('aria-label', 'Buy now — express checkout');

    /* Match source button's width on desktop. Mobile CSS forces 100%. */
    var srcRect = srcEl.getBoundingClientRect();
    if (srcRect && srcRect.width > 0) {
      buyBtn.style.setProperty('width', Math.round(srcRect.width) + 'px', 'important');
    }

    var label = document.createElement('span');
    label.textContent = 'BUY NOW →';
    label.style.cssText = 'display:inline-block;width:100%;text-align:center;letter-spacing:inherit;color:inherit;font:inherit;';
    buyBtn.appendChild(label);

    var parent = srcEl.parentNode;
    var parentDisplay = window.getComputedStyle(parent).display;
    if (/^(flex|inline-flex)/.test(parentDisplay)) {
      var wrap = document.createElement('div');
      wrap.className = 'leu-buy-now-wrap-injected';
      wrap.style.cssText = 'flex-basis:100%;width:auto;margin-bottom:10px;display:flex;justify-content:flex-start;';
      wrap.appendChild(buyBtn);
      parent.insertBefore(wrap, srcEl);
    } else {
      /* Block parent — add margin between the two buttons. */
      buyBtn.style.setProperty('margin-bottom', '10px', 'important');
      parent.insertBefore(buyBtn, srcEl);
    }
  }

  /* Apply noir restyle to the (now-rewritten) ATC so visual hierarchy is clear:
   * gold BUY NOW on top, noir ADD TO CART below. */
  function restyleATC(el) {
    if (!el) return;
    el.classList.add('leu-atc-restyled');
  }

  function rewriteBuyButtons() {
    var candidates = document.querySelectorAll('a, button');
    for (var i = 0; i < candidates.length; i++) {
      var el = candidates[i];
      if (el.dataset.leuBuyHijacked) continue;
      var text = (el.textContent || '').trim();
      var href = el.getAttribute && el.getAttribute('href');
      var isBuyText = /^(buy now|buy|shop|order now)$/i.test(text);
      var isChlHref = href && /coasthighwayliquor\.myshopify\.com/i.test(href);
      if (!isBuyText && !isChlHref) continue;

      var leuHandle = resolveLeuHandle(el);
      if (!leuHandle) continue;

      el.dataset.leuBuyHijacked = '1';
      try {
        if (text === text.toUpperCase()) el.textContent = 'ADD TO CART';
        else if (text === text.toLowerCase()) el.textContent = 'add to cart';
        else el.textContent = 'Add to cart';
      } catch (e) {}

      el.addEventListener('click', function (handle) {
        return function (ev) {
          ev.preventDefault();
          ev.stopImmediatePropagation();
          if (!window.LeucadiaCart || !window.LEUCADIA_CHL || !window.LEUCADIA_CHL.lookup) return;
          var meta = window.LEUCADIA_CHL.lookup(handle);
          if (!meta) { console.warn('[Leucadia] no CHL mapping for', handle); return; }
          var scope = ev.currentTarget.closest('section, .shopify-section, [class*="section"]') || document.body;
          var img = scope.querySelector('img');
          window.LeucadiaCart.add({
            key: handle,
            chlVariantId: meta.variantId,
            title: meta.title,
            price: meta.price,
            image: img && img.src ? img.src : '',
            qty: 1
          });
          window.LeucadiaCart.open();
        };
      }(leuHandle), true);

      /* Insert Buy Now FIRST (above), then restyle ATC to noir. */
      insertBuyNowButton(el, leuHandle);
      restyleATC(el);
    }
  }

  function syncCount() {
    var count = leuCartCount();
    var bubbles = document.querySelectorAll('.cart-count-bubble');
    for (var i = 0; i < bubbles.length; i++) {
      var b = bubbles[i];
      var numSpan = b.querySelector('span[aria-hidden="true"]') || b.querySelector('span:not(.visually-hidden)') || b;
      if (numSpan) numSpan.textContent = count > 0 ? count : '';
      b.style.display = count > 0 ? '' : 'none';
    }
    if (!bubbles.length) {
      var cartIcon = document.querySelector('#cart-icon-bubble, .header__icon--cart');
      if (cartIcon) {
        var leuSpan = cartIcon.querySelector('.leu-cart-count');
        if (!leuSpan && count > 0) {
          leuSpan = document.createElement('span');
          leuSpan.className = 'leu-cart-count';
          leuSpan.style.cssText = 'position:absolute;top:-4px;right:-4px;min-width:18px;height:18px;padding:0 4px;border-radius:9px;background:#D4AF50;color:#080808;font-family:sans-serif;font-size:11px;font-weight:700;display:inline-flex;align-items:center;justify-content:center;z-index:5;';
          cartIcon.style.position = cartIcon.style.position || 'relative';
          cartIcon.appendChild(leuSpan);
        }
        if (leuSpan) {
          if (count > 0) leuSpan.textContent = count;
          else leuSpan.remove();
        }
      }
    }
  }

  function hideDawnDrawer() {
    var dawn = document.querySelector('cart-drawer');
    if (dawn) dawn.style.display = 'none';
    var notif = document.querySelector('cart-notification');
    if (notif) notif.style.display = 'none';
  }

  function init() {
    injectBuyNowStyles();
    hijackCartLinks();
    rewriteBuyButtons();
    syncCount();
    hideDawnDrawer();
  }

  document.addEventListener('leucadia:cart:change', syncCount);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  setTimeout(init, 1500);
  setTimeout(init, 3500);
  setTimeout(init, 6500);
})();
